module.exports = ".titulo-menu-sidebar {\r\n    color: #6d6d6d;\r\n    font-size: 8pt;\r\n    font-weight: bold;\r\n    margin-left: 5px;\r\n}\r\n.nav-bar-disabled {\r\n    color: #212529;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.css
// module id = ./src/app/sidebar/sidebar.component.css
// module chunks = main